import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { SamhitaOndcWoCService } from 'src/app/shared/services/api/samhita-ondc-wo-c.service';
import { SharedService } from 'src/app/shared/services/other/shared.service';
import { REDIRECTION_INFO, SESSION_STORAGE_KEYS } from 'src/app/shared/types/types';

@Component({
  selector: 'app-o-auth-call-back',
  templateUrl: './o-auth-call-back.component.html',
  styleUrls: ['./o-auth-call-back.component.scss']
})
export class OAuthCallBackComponent implements OnInit {
  state = 'loading'
  deepLinkUrl = '';
  showOpenAppButton = false;

  constructor(private activatedRoute : ActivatedRoute,private samhitaWoService : SamhitaOndcWoCService,private router:Router,private sharedService : SharedService) { }

  routeParams : {code : string , state:string} = { code : '' , state : ''}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res:any)=>{
      const { code , state } = res
      this.routeParams.code = code
      this.routeParams.state = state
      this.getTheTokenDetails()
    })
  }

  getTheTokenDetails(){
    this.samhitaWoService.getOAuthTokenDetails({code : this.routeParams.code , state : this.routeParams.state}).subscribe((res:any)=>{
      this.state = 'success'
      const { access_token , is_new_user } = res
      const redirectionInfo : REDIRECTION_INFO = { PARAM_URL : 'profile' , QUERY_PARAMS : { editing : true}}
      if(is_new_user) this.sharedService.setDataToSessionStorage({key : SESSION_STORAGE_KEYS.REDIRECTION_DATA , data : redirectionInfo})
      
      // Redirect based on platform
      this.handleRedirection(access_token, is_new_user)
    },(err:any)=>{
      this.state = 'failed'
    })
  }

  /**
   * Check if on Android device
   */
  private isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }

  /**
   * Handles redirection after OAuth success
   */
  private handleRedirection(accessToken: string, isNewUser: boolean): void {
    const isNative = Capacitor.isNativePlatform();
    
    if (isNative) {
      // Already inside the app - just navigate
      this.router.navigate(['auth', accessToken]);
    } else if (this.isAndroid()) {
      // Android browser - show button for user to tap (Chrome blocks auto-redirect)
      this.deepLinkUrl = `skillmantra://auth?token=${encodeURIComponent(accessToken)}&is_new_user=${isNewUser}`;
      this.showOpenAppButton = true;
    } else {
      // Desktop browser - navigate within web app
      this.router.navigate(['auth', accessToken]);
    }
  }

  openApp() {
    window.location.href = this.deepLinkUrl;
  }

  goToLogin(){
    this.router.navigate(['/login'])
  }

}
